export function parseDOMString(html: string, querySelector: string, text: string) {
  const domparser = new DOMParser();
  const doc = domparser.parseFromString(html, 'text/html');
  const elem = doc.querySelector(querySelector) as HTMLElement;
  elem.insertAdjacentText('beforeend', text);
  return doc.body.innerHTML;
}

/**
 * @returns new html by removing
 * element selected by queryselector
 */

export function removeElement(html: string, querySelector: string) {
  const domparser = new DOMParser();
  const doc = domparser.parseFromString(html, 'text/html');
  const elem = doc.querySelector(querySelector) as HTMLElement;
  elem.remove();
  return doc.body.innerHTML;
}
